import {
  Box,
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Page from "../../component/Page";
import { REPORT_CONFIG } from "./config";
import api from "../../api/api";
import { saveAs } from "file-saver";
export default function ReportPlanSale() {
  const [y, setY] = useState(new Date().getFullYear() + 543);
  const [reports, setReports] = useState([]);
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loading, setloading] = useState(false);
  const [version, setVersion] = useState('1');

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  async function getReportPlanSale2(body, mode, format) {
    const url = `${REPORT_CONFIG.requests.getReportPlanSale2.url}/${mode}`;
    let _params = "";
    let _y = "";
    let _v = "";
    let _format = "";
    if (body.y) {
      _y = "y=" + body.y;
    }
    if (body.v) {
      _v = "&v=" + body.v;
    }

    if (format) {
      _format = "&format=" + format;
    }
    _params = "?" + _y + _v + _format;
    if (mode === "file") {
      setloadingDownload(true);
      const res = await api.get(url + _params, { responseType: "arraybuffer" });
      const data = res.data;
      if (format) {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, "แผนการจำหน่ายเมล็ดพันธุ์ข้าว (กมข-20402)");
      } else {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "แผนการจำหน่ายเมล็ดพันธุ์ข้าว (กมข-20402)");
      }
      setloadingDownload(false);
    } else {
      setloading(true);
      const res = await api.get(url + _params);
      const data = res.data.result;
      setReports(data);
      setloading(false);
    }
  }
  useEffect(() => {
    LoadReport();
  }, []);
  async function LoadReport() {
    const body = {
      y: y,
      v: version
    };
    getReportPlanSale2(body, "data");
  }
  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <div class="container-fluid p-0">
          <form>
            <div class="row  no-gutters">
              <div class="col-12 col-lg-2">
                <div class="row no-gutters">
                  <div class="col-12 header-row border-1 ">ตัวกรอง</div>
                </div>
                <div class="row no-gutters p-2 border-1">
                  <div class="col-12">
                    <label class="labelInput">ปีงบประมาณ</label>

                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <TextField
                        value={y}
                        onChange={(e) => setY(e.target.value)}
                        variant="standard"
                        fullWidth
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                  </div>
                  <div class="col-12">
                    <RadioGroup
                      value={version || ""}
                      onChange={(e) => setVersion(e.target.value)}
                      row
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="ครั้งที่ 1 (ต.ค. - ก.ย.)"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="ครั้งที่ 2 (เม.ย. - ก.ย.)"
                      />
                    </RadioGroup>
                  </div>

                  <div class="col-12">
                    <Button
                      onClick={LoadReport}
                      disabled={loading ? true : false}
                      variant="contained"
                      className="ButtomSearch"
                    >
                      {loading ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ค้นหา"
                      )}{" "}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between header-row border-1 ">
                    <div>แผนการจำหน่ายเมล็ดพันธุ์ข้าว (กมข-20402)</div>
                    <Button
                      variant="contained"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      disabled={loadingDownload ? true : false}
                      onClick={handleClick}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ดาวน์โหลด"
                      )}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          const body = {
                            y: y,
                            v: version
                          };
                          // setFormat('')
                          getReportPlanSale2(body, "file");

                          handleClose();
                        }}
                      >
                        Excel
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          const body = {
                            y: y,
                            v: version
                          };
                          // setFormat('pdf')
                          getReportPlanSale2(body, "file", "pdf");

                          handleClose();
                        }}
                      >
                        Pdf
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <div class="row no-gutters border-1 pt-3">
                  <div class="report col-12">
                    <div class="table-responsive-sm">
                      <div class="table-responsive-sm">
                        <table class="table table-bordered table-sm table-hover">
                          <thead class="sticky-thead">
                            <tr>
                              <th scope="col" rowspan="2">
                                ที่
                              </th>
                              <th scope="col" rowspan="2">
                                ศูนย์เมล็ดพันธุ์ข้าว
                              </th>
                              <th scope="col" rowspan="2">
                                พันธุ์
                              </th>
                              <th scope="col" colspan="12">
                                ปริมาณเมล็ดพันธุ์ที่คาดว่าจะจำหน่ายได้ (ตัน)
                              </th>
                              <th scope="col" rowspan="2">
                                รวม (ตัน)
                              </th>
                            </tr>
                            <tr>
                              <th scope="col">ต.ค.</th>
                              <th scope="col">พ.ย.</th>
                              <th scope="col">ธ.ค.</th>
                              <th scope="col">ม.ค.</th>
                              <th scope="col">ก.พ.</th>
                              <th scope="col">มี.ค.</th>
                              <th scope="col">เม.ย.</th>
                              <th scope="col">พ.ค.</th>
                              <th scope="col">มิ.ย.</th>
                              <th scope="col">ก.ค.</th>
                              <th scope="col">ส.ค.</th>
                              <th scope="col">ก.ย.</th>
                            </tr>
                          </thead>
                          <tbody>
                            {reports?.map((report, i) => (
                              <tr class="cp">
                                <td>{report?.Index}</td>
                                <td>{report?.BranchName}</td>
                                <td>{report?.CatalogName}</td>

                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_10 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_11 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_12 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_1 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_2 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_3 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_4 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_5 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_6 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_7 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_8 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                                <td class="text-center">
                                  {parseFloat(report?.TargetMonth_9 / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>

                                <td class="text-center">
                                  {parseFloat(report?.SumTarget / 1000)
                                    .toFixed(3)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                {reports.length === 0 && (
                  <div class="row">
                    <div class="col-12">
                      <div class="not-found">ไม่พบข้อมูล</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Page>
    </div>
  );
}
